import { BETTING_LIMIT_ACTION_TYPE } from "./betting-limit.action";
import { BettingLimitType, LimitPeriod } from "./betting-limit.model";

export const BETTING_LIMIT_MESSAGE_CONTEXT = {
	getBetCountLimit: BETTING_LIMIT_ACTION_TYPE.getBetCountLimit,
	getBetSizeLimit: BETTING_LIMIT_ACTION_TYPE.getBetSizeLimit,
	getWageringLimit: BETTING_LIMIT_ACTION_TYPE.getWageringLimit,
	getTimedWageringLimit: BETTING_LIMIT_ACTION_TYPE.getTimedWageringLimit,
	getNetlossLimit: BETTING_LIMIT_ACTION_TYPE.getNetlossLimit,
	updateBetCountLimit: BETTING_LIMIT_ACTION_TYPE.updateBetCountLimit,
	updateBetSizeLimit: BETTING_LIMIT_ACTION_TYPE.updateBetSizeLimit,
	updateWageringLimit: BETTING_LIMIT_ACTION_TYPE.updateWageringLimit,
	updateTimedWageringLimit: BETTING_LIMIT_ACTION_TYPE.updateTimedWageringLimit,
	updateNetlossLimit: BETTING_LIMIT_ACTION_TYPE.updateNetlossLimit,
	deleteBetCountLimit: BETTING_LIMIT_ACTION_TYPE.removeBetCountLimit,
	deleteBetSizeLimit: BETTING_LIMIT_ACTION_TYPE.removeBetSizeLimit,
	deleteWageringLimit: BETTING_LIMIT_ACTION_TYPE.removeWageringLimit,
	deleteTimedWageringLimit: BETTING_LIMIT_ACTION_TYPE.removeTimedWageringLimit,
	deleteTimedWageringLimitWithPayload: BETTING_LIMIT_ACTION_TYPE.removeTimedWageringLimitWithPayload,
	deleteNetlossLimit: BETTING_LIMIT_ACTION_TYPE.removeNetlossLimit,
	deleteNetlossLimitWithPayload: BETTING_LIMIT_ACTION_TYPE.removeNetlossLimitWithPayload,
};

export const LIMIT_PERIODS = new Map([
	[LimitPeriod.Daily, "day"],
	[LimitPeriod.Weekly, "week"],
	[LimitPeriod.Monthly, "month"],
	["Yearly", "year"],
]);

export const BETTING_LIMIT_REMOVE_ALERT_ID = "BETTING_LIMIT_REMOVE_ALERT_ID";
export const BETTING_LIMIT_SUBMIT_ALERT_ID = "BETTING_LIMIT_SUBMIT_ALERT_ID";
export const TRANSLATION_PREFIX = "betting-limit";

export const BETTING_LIMIT_PERIODS: any[] = [
	{ value: LimitPeriod.Daily, label: `${TRANSLATION_PREFIX}.daily` },
	{ value: LimitPeriod.Weekly, label: `${TRANSLATION_PREFIX}.weekly` },
	{ value: LimitPeriod.Monthly, label: `${TRANSLATION_PREFIX}.monthly` },
];

export const BETTING_LIMIT_PERIODS_TYPE: any[] = [
	{ value: BettingLimitType.WageringLimit, label: `${TRANSLATION_PREFIX}.max-cash` },
	{ value: BettingLimitType.BetSizeLimit, label: `${TRANSLATION_PREFIX}.bet-size-limit` },
];
